import styles from './StatusCentralPage.module.css'

const STATUS_URL = 'https://statuscentral.apteancloud.dev/'

export function StatusCentralPage() {
  return (
    <div className={styles.iframePage}>
      <iframe
        src={STATUS_URL}
        title="Status Central"
        className={styles.iframe}
        allow="fullscreen"
      />
    </div>
  )
}
